<template>
  <!-- 新增提货 -->
  <div class="pickUp-detail-edit">
    <el-form
      :model="dataForm"
      ref="dataForm"
      label-position="top"
      class="dataForm"
      :rules="rules"
    >
      <div class="logisticsInfo">
        <h3>提货信息</h3>

        <el-row :gutter="20" class="basic-row">
          <el-col :span="8">
            <el-form-item
              label="业务类型"
              prop="bizTypeGroup"
              style="margin-bottom:12px"
            >
              <el-select
                v-model="dataForm.bizTypeGroup"
                disabled
                placeholder="请选择业务类型"
                clearable
              >
                <el-option label="进口" value="01" />
                <el-option label="出口" value="02" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="提货时间"
              prop="deliveryTime"
              style="margin-bottom:12px"
            >
              <ab-dateTimePick v-model="dataForm.deliveryTime" :gutter="0" class="merge-input"></ab-dateTimePick>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="件数"
              prop="packedQty"
              style="margin-bottom:12px"
            >
              <el-input
                v-model="dataForm.packedQty"
                placeholder="请输入件数"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="companyName">
          <ab-select2
            v-model="dataForm.companyName"
            url="/bas/client/basAddress/list"
            :urlData="{ data: { bizTypeGroup: dataForm.bizTypeGroup, companyName: dataForm.companyName, addressType: '04', isEnabled: 1 } }"
            inputKey="companyName"
            label="发货公司"
            required
            @handleSelect="companyNameSelect"
            @handlerAdd="companyNameAdd"
          ></ab-select2>
        </el-form-item>

        <div
          v-if="dataForm.companyName"
          class="receivingAddress">
          <ab-svg name="dingwei"></ab-svg>
          {{ dataForm.addressContent }}/{{ dataForm.linkMan }}/{{ dataForm.linkPhone }}
        </div>

        <el-row :gutter="20" class="other-row">
          <el-col :span="8">
            <el-form-item label="卡板数" prop="cardBoard" style="margin-bottom:15px">
              <el-input
                v-model="dataForm.cardBoard"
                placeholder="请输入卡板数"
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item
              label="备注"
              class="remarks"
              style="margin-bottom:15px"
            >
              <el-input
                v-model="dataForm.remarks"
                :rows="1"
                type="textarea"
                placeholder="有什么问题可以在这里备注哟！"
                :autosize="{maxRows: 5 }"
                resize="none"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>

    <ab-handlerAds
      :dialog="addressData"
      ref="handlerAds"
      @change="handlerAddress"
    ></ab-handlerAds>
  </div>
</template>

<script>
export default {
  props: {
    options: {
      type: Object,
      default () {
        return {}
      }
    },

    dataForm: {
      type: Object,
      default () {
        return {}
      }
    }
  },

  data() {
    const cardBoardVer = (rule, value, callback) => {
      if (value == '') {
        return callback();
      }
      if (!/^[+]{0,1}(\d+)$/.test(value)) {
        callback(new Error('请输入0或者正整数'))
      }
      callback()
    }
    const packedQtyVer = (rule, value, callback) => {
      if (!value && value !== 0) {
        return callback(new Error('请输入件数'));
      }
      if (!/^[+]{0,1}(\d+)$/.test(value)) {
        callback(new Error('请输入0或者正整数'))
      }
      callback()
    }

    return {
      rules: {
        bizTypeGroup: [
          { required: true, message: '请选择业务类型', trigger: 'change' },
        ],
        
        deliveryTime: [
          { required: true, message: '提货时间不能为空', trigger: 'blur' },
        ],

        companyName: [
          { required: true, message: '请选择发货公司', trigger: 'change' },
        ],

        packedQty: [
          { required: true, validator:packedQtyVer, trigger: 'change' },
        ],

        cardBoard: [
          { validator:cardBoardVer, trigger: 'change' },
        ]
      },
      addressData: {
        type: '02', //业务类型 01 进口，02 出口
        addressType: '04', //地址类型 01收货，04发货
        bizTypeGroup: '02',
        isEnabled: true,
        show: false,
        noClient: true
      }
    }
  },

  computed: {

  },

  methods: {
    // 发货公司
    companyNameSelect(row) {
      if (!row) {
        this.dataForm.addressIdList = []
        this.dataForm.addressContent = ''
        this.dataForm.linkMan = ''
        this.dataForm.linkPhone = ''
      } else {
        this.dataForm.addressIdList = row.addressIdsDesc
        this.dataForm.addressContent = row.addressContent
        this.dataForm.linkMan = row.linkMan
        this.dataForm.linkPhone = row.linkPhone
      }
    },

    // 发货公司-新增
    companyNameAdd() {
      this.addressData.type = this.dataForm.bizTypeGroup
      this.addressData.bizTypeGroup = this.dataForm.bizTypeGroup
      this.addressData.companyName = this.dataForm.supplierName
      this.addressData.sourceBillId = this.dataForm.supplierId
      this.addressData.sourceBillType = 'Supplier'
      this.addressData.show = true
    },

    // 地址
    handlerAddress(row) {
      this.dataForm.companyName = row.companyName
      this.dataForm.addressIdList = row.address
      this.dataForm.addressContent = row.addressContent
      this.dataForm.linkMan = row.linkMan
      this.dataForm.linkPhone = row.linkPhone
    }
  }
}
</script>

<style lang='scss'>
.pickUp-detail-edit {
  position: relative;
  padding: 35px 0 0 0;
  text-align: left;
  border-top: 1px solid #f0f2f5;
  color: #000000;
  // min-height: 800px;
  .el-form-item__label {
    color: #000000;
  }
  h3 {
    font-size: 18px;
    margin-bottom: 32px;
  }
  .logisticsInfo {
    margin-bottom: 20px;
    .basic-row {
      margin-bottom: 6px;
    }
    .other-row {
      margin-top: 35px;
    }
    .supplierName {
      width: 100%;
      display: flex;
      padding: 20px 0;
      border-bottom: 1px solid #f0f2f5;
      line-height: 24px;
      .supplier {
        padding: 5px 12px;
        height: 24px;
        line-height: 14px;
        border-radius: 4px;
        background-color: #f0f2f5;
        span {
          color: #fe2424;
        }
      }
      .icon-svg {
        width: 24px;
        height: 24px;
        vertical-align: middle;
        margin: 0 10px;
        cursor: pointer;
      }
      p {
        font-size: 22px;
        font-weight: bold;
      }
    }
    .receivingAddress {
      font-size: 14px;
      font-weight: 400;
      margin: 18px 0 0 0;
      .icon-svg {
        width: 11px;
        height: 16px;
        vertical-align: bottom;
      }
    }
    .remarks {
      .el-textarea {
        .el-textarea__inner {
          min-height: 45px !important;
          padding-top: 11px;
          box-shadow: 0 0 0 1px transparent;
          &:focus {
            box-shadow: 0 0 0 1px var(--el-input-focus-border-color) inset;
          }
        }
      }
    }
    .pinkUpTime {
      position: relative;
      .el-input {
        width: 100%;
      }
      .el-col:nth-child(1) {
        .el-input__wrapper {
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
      .el-col:nth-child(2) {
        .el-form-item__label::before {
          display: none;
        }
        .el-input__wrapper {
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
      }

      .dividingLine {
        position: absolute;
        top: 52px;
        left: 50%;
        width: 1px;
        height: 15px;
        background-color: #b5b5b5;
        margin: 0 5px;
      }
    }
  }
  .merge-input {
    .el-col {
      &:nth-child(1) {
        position: relative;
        &::after {
          position: absolute;
          top: 16px;
          right: 0;
          z-index: 2;
          content: '';
          width: 1px;
          height: 14px;
          background: #B5B5B5;
        }
      }
    }
  }
  .footer {
    position: absolute;
    bottom: 0;
    padding: 20px 0;
    margin: 0;
    width: 100%;
    text-align: center;
    border-top: 1px solid #f0f2f5;
  }
}
</style>